export default __webpack_public_path__ + "static/media/skewers.81a1b19a.jpg";